export default "/_next/static/images/f3eabc84a24e475aa59688023747fa8a.png";